var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"retire-action-popup"},[_c('action-popup',{attrs:{"value":_vm.value,"headline":`Retire Position`,"htmlInfo":_vm.generateInfo(),"icon":_vm.generateIconName(),"actionLabel":"Retire","termination":true,"deletePopup":true,"titleMarginTop":"70px","iconLeft":"0px"},on:{"input":_vm.closePopup,"onAction":_vm.onAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }